import * as Yahoo from './Yahoo';

// Yahoo Finance API for TASE (Tel Aviv Stock Exchange) - Live data
export const TASE_STOCK_FUNCTIONS = {
	search: Yahoo.search,
	get_instrument_chart_data: Yahoo.get_instrument_chart_data,
	extract_chart_point: Yahoo.extract_chart_point,
	extract_table_info: Yahoo.extract_table_info,
	extract_chart_length: Yahoo.extract_chart_length,
	filter_indices: Yahoo.filter_indices,
	// Additional Yahoo functions
	getQuote: Yahoo.getQuote,
	listIndices: Yahoo.listIndices,
	listTASEStocks: Yahoo.listTASEStocks,
	searchYahooFinance: Yahoo.searchYahooFinance,
	// Autocomplete functions (use local data.js)
	autocomplete: Yahoo.autocomplete,
	autocompleteIndices: Yahoo.autocompleteIndices,
	getAllStocks: Yahoo.getAllStocks,
};

export const NY_STOCK_FUNCTIONS = {
	// Can be extended to support NYSE stocks via Yahoo Finance
	search: Yahoo.search,
	get_instrument_chart_data: Yahoo.get_instrument_chart_data,
	extract_chart_point: Yahoo.extract_chart_point,
	extract_table_info: Yahoo.extract_table_info,
	extract_chart_length: Yahoo.extract_chart_length,
	filter_indices: Yahoo.filter_indices,
	// Autocomplete functions
	autocomplete: Yahoo.autocomplete,
	autocompleteIndices: Yahoo.autocompleteIndices,
};
